module.exports = __webpack_public_path__ + "static/media/aboutUs_03.6a2e5344.png";